var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardFundPayrollIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 235,
    height: 173,
    viewBox: "0 0 235 193",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M63.3055 16.9147C60.779 1.24122 47.2843 -10.7402 31.0375 -10.7402C12.9941 -10.7402 -1.65539 4.0385 -1.65539 22.2426C-1.65539 40.4462 12.9941 55.2255 31.0375 55.2255C33.6513 55.2255 36.4612 54.4509 38.898 53.8653C38.1087 48.4376 43.4701 41.5098 50.5961 47.1322C51.901 45.1769 52.8175 44.0059 53.5734 41.8824C51.7859 43.7525 48.5704 44.8865 46.31 45.1734C44.4252 45.4127 42.3407 45.3336 40.0767 44.9002C36.2569 21.4026 48.359 12.662 63.3055 16.9147Z",
    fill: "#C8C4FF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.0712 40.4668C53.4557 42.9427 52.376 45.0591 50.8151 46.7386",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7513 115.104C34.1238 127.523 41.187 132.794 53.6419 126.765C50.0548 124.171 47.3868 120.265 44.7513 115.104ZM94.061 71.1103C98.1292 74.7531 101.76 71.8945 96.9414 62.1436C96.9414 62.1436 94.9725 68.7302 94.061 71.1103Z",
    fill: "#653494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.609 105.383C131.392 118.594 145.263 127.655 161.256 127.655C183.926 127.655 202.332 109.448 202.332 87.0231C202.332 64.5982 183.926 46.3916 161.256 46.3916C144.893 46.3916 130.752 55.8764 124.149 69.5865",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.429 127.653C162.429 127.653 145.85 127.655 168.521 127.655C191.191 127.655 209.597 109.448 209.597 87.0231C209.597 64.5982 191.191 46.3916 168.521 46.3916L162.429 46.3931",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.874 100.635C148.094 105.192 152.375 109.376 161.732 109.376C170.453 109.376 176.637 105.13 176.637 98.3872C176.637 83.2785 148.332 87.0866 148.332 73.9133C148.332 68.8561 153.168 64.6729 161.494 64.6729C167.688 64.6729 171.215 67.0443 173.168 69.2713",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.681 61.29V112.757",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M163.83 61.29V112.757",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M81.0921 99.5764C74.2135 112.227 82.0178 114.208 88.2648 99.514C88.2648 99.514 81.9133 99.2327 81.0921 99.5764ZM56.2208 18.9926C61.6957 35.9451 54.5671 47.6731 40.0769 44.9002C35.009 13.7235 57.9687 8.5254 78.4104 25.1834C75.7135 28.9925 72.7591 31.6995 69.4473 32.8726C67.2821 26.0426 62.9448 21.3458 56.2208 18.9926Z",
    fill: "#653494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M81.0921 99.5137C90.0537 99.5137 128.02 99.5137 136.981 99.5137C137.44 99.5137 137.881 99.6977 138.205 100.025C138.53 100.353 138.712 100.797 138.712 101.26V101.26C138.712 101.723 138.53 102.167 138.205 102.494C137.881 102.822 137.44 103.006 136.981 103.006C128.02 103.006 95.554 103.006 86.5923 103.006",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.514 99.5137C103.973 99.5137 104.413 99.6977 104.738 100.025C105.062 100.353 105.245 100.797 105.245 101.26V101.26C105.245 101.723 105.062 102.167 104.738 102.494C104.413 102.822 103.973 103.006 103.514 103.006",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M97.7976 101.261H96.0674",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.872 101.261H99.8116",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.624 73.7461C152.879 73.2747 152.867 72.7044 152.592 72.2446C152.318 71.7843 151.822 71.5029 151.286 71.5029C144.529 71.5029 126.279 71.5029 120.452 71.5029C119.334 71.5029 118.307 72.1158 117.776 73.0993C114.569 79.0385 103.514 99.5142 103.514 99.5142H138.712C138.712 99.5142 149.036 80.3916 152.624 73.7461Z",
    fill: "#E3E1FF"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M152.624 73.7461C152.879 73.2747 152.867 72.7044 152.592 72.2446C152.318 71.7843 151.822 71.5029 151.286 71.5029C144.529 71.5029 126.279 71.5029 120.452 71.5029C119.334 71.5029 118.307 72.1158 117.776 73.0993C114.569 79.0385 103.514 99.5142 103.514 99.5142H138.712C138.712 99.5142 149.036 80.3916 152.624 73.7461Z",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M130.265 82.7754C127.868 82.7754 124.967 84.3697 123.791 86.3331C122.616 88.2964 123.607 89.8908 126.005 89.8908C128.402 89.8908 131.303 88.2964 132.478 86.3331C133.654 84.3697 132.662 82.7754 130.265 82.7754Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.052 71.1015C96.9182 63.8918 99.5203 53.011 100.251 45.1007C101.989 43.7462 103.37 41.8903 104.264 39.348C105.897 37.6883 107.239 35.7949 108.278 33.6571C108.38 33.4452 108.323 33.1912 108.141 33.0427C108.142 33.0422 108.141 33.0422 108.141 33.0422C108.009 32.9342 107.839 32.8861 107.67 32.9089C107.501 32.9322 107.349 33.0245 107.251 33.1634C106.18 34.669 104.971 35.9916 103.606 37.1043M83.5639 69.2892C83.5639 69.2892 91.9132 48.9499 93.9926 43.8836C94.2963 43.1429 94.3906 42.3333 94.2644 41.543C93.9328 39.4707 93.2921 35.4603 93.2921 35.4603C93.2921 35.4603 93.7321 32.3315 93.9845 30.5379C94.016 30.3144 94.1736 30.1288 94.3896 30.0614C94.605 29.9945 94.8402 30.0579 94.9933 30.2246C95.0126 30.2459 95.0309 30.2652 95.0471 30.2834C95.112 30.3539 95.1586 30.4401 95.1829 30.5329C95.4653 31.6664 95.5408 33.0569 95.4161 34.6933C96.6013 35.2484 97.3937 36.6455 97.8413 37.8672L83.5639 69.2892Z",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.074 36.7086C105.187 34.6561 106.114 31.8694 106.541 29.461C106.58 29.2288 106.455 29.0002 106.239 28.9074C106.239 28.9074 106.239 28.9074 106.239 28.9074C106.083 28.841 105.906 28.842 105.751 28.9109C105.596 28.9794 105.476 29.1092 105.42 29.2694C104.805 31.0173 104.007 32.6278 103 34.0802",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.2674 60.0848C73.2674 60.0848 76.9965 68.1142 79.3061 73.0872C80.4406 75.5302 80.4594 78.3452 79.3583 80.8038C77.6038 84.7204 75.1477 90.2029 75.1477 90.2029M102.547 35.3767C103.449 33.2161 104.032 28.6669 104.207 26.0546C104.221 25.8204 104.073 25.6065 103.849 25.537C103.849 25.5365 103.848 25.5365 103.848 25.5365C103.686 25.4858 103.509 25.5056 103.361 25.5908C103.213 25.6759 103.107 25.8184 103.069 25.9847C102.528 28.1929 101.355 31.8945 100.63 33.1497L102.547 35.3767ZM100.361 34.0733C100.729 31.7612 100.224 27.2115 99.7792 24.6301C99.7372 24.3934 99.5379 24.2165 99.2981 24.2023C99.2976 24.2023 99.2976 24.2023 99.2976 24.2023C99.1288 24.1921 98.9631 24.2525 98.8404 24.3691C98.7177 24.4851 98.6483 24.6474 98.6493 24.8167C98.6118 26.6589 98.2843 29.4247 98.0886 31.2512C98.0288 31.8748 97.8686 32.4851 97.6146 33.0574C97.5786 33.1396 97.5553 33.1928 97.5553 33.1928L96.6601 35.2089L100.361 34.0733ZM102.742 38.9795C101.62 37.6214 100.237 36.5624 98.3659 36.0651L102.742 38.9795ZM98.5742 72.0232C94.5684 80.121 91.5968 86.006 87.5073 88.6786C85.4998 89.9773 82.8556 89.6833 81.1828 87.9755C79.6766 86.4415 77.946 84.6748 77.946 84.6748L98.5742 72.0232Z",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4623 64.4141L61.8208 86.8643",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.4623 85.1963L85.2819 93.3772L89.4828 94.7642L97.0245 95.7036L102.968 99.5147",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.7707 44.4873C64.1538 48.6619 62.8489 51.7375 60.0572 55.1994M78.714 109.417C67.0575 107.319 55.4025 105.551 43.7359 100.705C41.2706 99.6573 39.5826 97.338 39.3433 94.671C38.1332 80.6826 38.1393 66.1325 39.064 50.9746C39.2206 48.448 40.8235 46.2398 43.1772 45.308C45.531 44.3758 48.2111 44.8878 50.0549 46.622C56.3267 52.5111 63.2449 59.0171 63.2449 59.0171L78.714 109.417ZM64.5801 48.9103C66.287 48.8561 67.9852 49.4522 69.3063 50.637C76.6244 57.1911 85.1846 64.8682 85.1846 64.8682L64.5801 48.9103ZM88.0969 58.2451C91.0529 75.7471 104.562 77.5614 96.9415 62.1429L88.0969 58.2451Z",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.2207 18.9932C75.0585 24.9517 73.7648 53.655 55.0624 41.5483",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.7012 105.24C31.0483 123.986 37.9193 134.072 53.2085 127.208M59.9057 29.5381C59.9057 29.5381 62.3395 31.7838 63.657 33.0005C64.0915 33.402 64.1711 34.059 63.8446 34.5527C63.2332 35.3821 63.1415 36.001 62.6594 36.3184L59.9057 29.5381ZM66.2556 38.1104C65.8612 39.4492 65.0673 40.0332 63.9105 39.9293L66.2556 38.1104ZM85.1228 93.3326C71.8882 111.286 81.1007 116.364 88.2648 99.5137L85.1228 93.3326Z",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.3754 100.522L39.4319 125.151",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M44.7513 115.104C54.7826 137.164 76.5535 135.802 108.781 116.433C108.781 116.433 109.044 116.29 109.515 116.034C112.585 114.368 116.385 114.922 118.851 117.396C121.317 119.869 121.859 123.671 120.184 126.736C109.991 145.373 96.833 169.431 93.0077 176.425C92.7395 176.916 92.2452 177.241 91.6886 177.293C91.1325 177.345 90.586 177.118 90.2317 176.686C87.845 173.771 86.4606 169.768 86.6846 164.02C86.6882 163.927 86.6998 163.835 86.7186 163.743C89.1453 152.056 90.4142 141.236 98.1151 125.594L44.7513 115.104ZM83.1285 177.137C81.8185 176.52 80.3292 178.526 78.8215 180.791C78.3648 184.079 78.7972 186.497 80.3413 187.826C80.9142 191.331 83.0458 196.096 84.9256 199.2C85.65 200.376 86.6507 201.358 87.8405 202.059C87.8339 202.07 87.8339 202.07 87.8339 202.07C88.5522 202.493 89.451 202.461 90.1364 201.987C90.2251 201.925 90.3138 201.864 90.3995 201.805C90.8882 201.467 91.169 200.901 91.1416 200.307C91.0012 197.252 90.5723 187.917 90.5723 187.917C90.5723 187.917 90.7766 187.225 91.0032 186.457C91.5274 184.68 90.9627 182.762 89.5595 181.553C87.7573 179.914 86.0616 180.49 84.0653 182.754C82.7006 181.718 82.6743 179.619 83.1285 177.137Z",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.4669 182.091C77.0102 185.379 77.692 187.402 79.2362 188.731C79.7624 191.953 81.6086 196.396 83.3642 199.559C84.2984 201.236 85.7042 202.601 87.4075 203.487C87.4034 203.494 87.4034 203.494 87.4034 203.494C87.9611 203.784 88.6039 203.864 89.2152 203.721C89.6613 203.616 90.0973 203.514 90.0973 203.514",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M91.6814 177.599L89.786 181.365",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.0943 177.144L86.6708 165.967",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.184 103.006C104.184 103.006 107.478 103.072 110.666 103.137C114.247 103.21 117.452 105.378 118.85 108.676C124.936 123.024 141.002 160.907 141.002 160.907C137.778 165.873 131.229 169.596 125.793 169.606C120.257 163.04 115.965 153.722 113.14 141.162",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.6907 127.461H93.1455",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-5.00007 127.461H39.5627",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.817 127.461H234",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156.265 179.162C148.578 182.161 140.444 183.945 132.175 184.418",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.139 174.82C138.927 179 134.716 180.319 131.563 178.349C130.288 181.088 130.238 183.659 131.317 186.074C140.467 185.79 148.763 183.826 157.148 180.515C157.539 180.36 157.819 180.011 157.885 179.596C157.953 179.182 157.797 178.762 157.475 178.492C157.427 178.449 157.379 178.41 157.336 178.373C157.128 178.198 156.87 178.094 156.598 178.075C151.452 177.711 147.034 175.93 142.923 173.53",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M139.594 172.143C143.281 170.863 143.494 175.589 141.321 177.426",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.78 166.14L139.56 176.122",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.817 169.778L132.191 178.693",
    stroke: "#200849",
    strokeWidth: 1.01387,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardFundPayrollIcon);
export default __webpack_public_path__ + "static/media/dashboard-fund-payroll-icon.8c3b365ccc2f48ef8e4fff51b221eabc.svg";
export { ForwardRef as ReactComponent };